import React, { useEffect, useState } from "react";

export default function AdminMemberLoginFilter({ onFilter }) {
  const [filters, setFilters] = useState({
    from_date: "",
    to_date: "",
    staff_name: "",
    profile_id: "",
    aadhar_verification: "",
    police_verification: "",
    photo_approval: "",
    caste_approval: "",
    education_approval: "",
    job_income_approval: "",
  });

  useEffect(() => {
    if (onFilter) {
      onFilter(filters);
    }
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFilters((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    onFilter?.(filters);
  };

  const handleReset = () => {
    const emptyFilters = {
      from_date: "",
      to_date: "",
      staff_name: "",
      profile_id: "",
      aadhar_verification: "",
      police_verification: "",
      photo_approval: "",
      caste_approval: "",
      education_approval: "",
      job_income_approval: "",
    };
    setFilters(emptyFilters);
    onFilter?.(emptyFilters);
  };

  return (
    <div className="filtercont" style={{ marginBottom: "20px" }}>
      <form onSubmit={handleSubmit}>
        <div className="row">
          <div className="col-lg-12">
            {/* Row 1: Date and ID filters */}
            <div className="row">
              <div className="col-12 col-sm-2 pr-lg-0">
                <label>From Date</label>
                <input
                  type="date"
                  name="from_date"
                  value={filters.from_date}
                  onChange={handleChange}
                  className="form-control"
                />
              </div>
              <div className="col-12 col-sm-2 pr-lg-0">
                <label>To Date</label>
                <input
                  type="date"
                  name="to_date"
                  value={filters.to_date}
                  onChange={handleChange}
                  className="form-control"
                />
              </div>
              <div className="col-12 col-sm-3 pr-lg-0">
                <label>Staff / Agent Search (Name, Email, Mobile)</label>
                <input
                  type="text"
                  name="staff_name"
                  placeholder="e.g. Rahul, anita@gmail.com, 9876543210"
                  value={filters.staff_name}
                  onChange={handleChange}
                  className="form-control"
                  title="Search using multiple comma-separated values simultaneously"
                />
              </div>
              <div className="col-12 col-sm-3 pr-lg-0">
                <label>Member Profile ID / Search</label>
                <input
                  type="text"
                  name="profile_id"
                  placeholder="e.g. VS0001, VS0002"
                  value={filters.profile_id}
                  onChange={handleChange}
                  className="form-control"
                  title="Search using multiple comma-separated IDs"
                />
              </div>
              {/* <div className="col-12 col-sm-2 pr-lg-0">
                <label>Aadhar Verification</label>
                <select
                  name="aadhar_verification"
                  value={filters.aadhar_verification}
                  onChange={handleChange}
                  className="form-control"
                >
                  <option value="">All</option>
                  <option value="Pending">Pending</option>
                  <option value="Verified">Verified</option>
                </select>
              </div>
              <div className="col-12 col-sm-2 pr-lg-0">
                <label>Police Verification</label>
                <select
                  name="police_verification"
                  value={filters.police_verification}
                  onChange={handleChange}
                  className="form-control"
                >
                  <option value="">All</option>
                  <option value="Pending">Pending</option>
                  <option value="Verified">Approved</option>
                  <option value="Rejected">Rejected</option>
                </select>
              </div> */}

              <div className="col-12 col-sm-4 pr-lg-0" style={{ display: "flex", alignItems: "flex-end", gap: "10px", marginTop: '10px' }}>
                <label>&nbsp;</label>

                <button type="submit" className="btn btn-default submit sitebtn px-3 text-center" >
                  <i className="fa fa-search" /> Search
                </button>
                <button type="button" onClick={handleReset} className="btn btn-default btn-small sitebtn">
                  Clear Filters
                </button>

              </div>
            </div>

            {/* Row 2: Verification status filters */}
            {/* <div className="row" style={{ marginTop: "10px" }}>
              <div className="col-12 col-sm-2 pr-lg-0">
                <label>Photo Approval</label>
                <select
                  name="photo_approval"
                  value={filters.photo_approval}
                  onChange={handleChange}
                  className="form-control"
                >
                  <option value="">All</option>
                  <option value="Pending">Pending</option>
                  <option value="Verified">Approved</option>
                  <option value="Rejected">Reject</option>
                </select>
              </div>
              <div className="col-12 col-sm-2 pr-lg-0">
                <label>Caste Approval</label>
                <select
                  name="caste_approval"
                  value={filters.caste_approval}
                  onChange={handleChange}
                  className="form-control"
                >
                  <option value="">All</option>
                  <option value="Pending">Pending</option>
                  <option value="Verified">Approved</option>
                </select>
              </div>
              <div className="col-12 col-sm-2 pr-lg-0">
                <label>Education Approval</label>
                <select
                  name="education_approval"
                  value={filters.education_approval}
                  onChange={handleChange}
                  className="form-control"
                >
                  <option value="">All</option>
                  <option value="Pending">Pending</option>
                  <option value="Verified">Approved</option>
                </select>
              </div>
              <div className="col-12 col-sm-2 pr-lg-0">
                <label>Job & Income</label>
                <select
                  name="job_income_approval"
                  value={filters.job_income_approval}
                  onChange={handleChange}
                  className="form-control"
                >
                  <option value="">All</option>
                  <option value="Pending">Pending</option>
                  <option value="Verified">Approved</option>
                </select>
              </div>
             
            </div> */}
          </div>
        </div>
      </form>
    </div>
  );
}